import { isTimeGroupbyField } from './chartUtils'
import { isGroupbyAvailable } from './collectionGroupby'

export const AUTO_INTERVAL = 'auto'

export const CHART_INTERVALS = [
  { value: AUTO_INTERVAL, label: 'Auto' },
  { value: 'hour', label: 'Hourly' },
  { value: 'day', label: 'Daily' },
  { value: 'month', label: 'Monthly' },
  { value: 'year', label: 'Yearly' },
]

const AUTO_INTERVAL_THRESHOLDS = [
  { maxDays: 2, interval: 'hour' },
  { maxDays: 92, interval: 'day' },
  { maxDays: 730, interval: 'month' },
]

const FALLBACK_INTERVAL = 'year'

export function supportsInterval(field) {
  if (!isTimeGroupbyField(field)) return false

  return !String(field).endsWith('_unittime')
}

export function resolveAutoInterval(startDate, endDate) {
  if (!startDate || !endDate) return 'day'

  const days = Math.abs(endDate.diff(startDate, 'days')) + 1
  const match = AUTO_INTERVAL_THRESHOLDS.find(threshold => days <= threshold.maxDays)

  return match ? match.interval : FALLBACK_INTERVAL
}

export function applyIntervalToField(field, interval) {
  const suffix = String(field).endsWith('_session') ? '_session' : ''

  return `${interval}${suffix}`
}

export function resolveChartInterval(chart, dates) {
  const [field] = chart?.dimensions || []
  if (!supportsInterval(field)) return null

  const interval = chart?.interval || AUTO_INTERVAL
  if (interval !== AUTO_INTERVAL) return interval

  return resolveAutoInterval(dates?.startDate, dates?.endDate)
}

export function resolveChartDimensionField(chart, config) {
  const [field] = chart?.dimensions || []
  if (!field) return null

  const interval = resolveChartInterval(chart, config)
  if (!interval) return field

  const next = applyIntervalToField(field, interval)

  return isGroupbyAvailable(config?.collection, next) ? next : field
}
